module.exports = __webpack_public_path__ + "static/media/hover-facebook.4b6e8637.svg";